import { useCallback, useState } from "react";
import { useServerFn } from "@tanstack/react-start";
import { createWebHandoffLink } from "@/app-bridge/functions/handoff.functions";
import { openWebHandoffUrl, isAppMode } from "@/app-bridge/core/wrapper";

/**
 * Skapar en engångslänk för att logga in på webben från appen.
 * Används för "Fortsätt på webben" / "Öppna på sellavo.com".
 */
export function useWebHandoff() {
  const createLink = useServerFn(createWebHandoffLink);
  const [loading, setLoading] = useState(false);

  const openOnWeb = useCallback(
    async (targetPath?: string) => {
      if (!isAppMode()) {
        // I webbläsaren öppnar vi bara samma sida i ett nytt fönster.
        window.open(targetPath?.startsWith("/") ? targetPath : window.location.pathname, "_blank");
        return { ok: true };
      }
      setLoading(true);
      try {
        const { url } = await createLink({ data: { targetPath } });
        const opened = await openWebHandoffUrl(url);
        return { ok: opened };
      } catch (err) {
        return { ok: false, error: err instanceof Error ? err.message : "Kunde inte skapa länken" };
      } finally {
        setLoading(false);
      }
    },
    [createLink],
  );

  return { openOnWeb, loading };
}
